import React from "react";
import { Scrollbar } from "@ptsd/uikit";
import type { VirtualItem } from "@tanstack/react-virtual";
import { useVirtualizer } from "@tanstack/react-virtual";
import type { ScrollViewProps } from "tamagui";
import { ScrollView, View } from "tamagui";

type RowVirtualizerProps = Omit<ScrollViewProps, "children"> & {
  count: number;
  estimateSize: number;
  children?: (virtualItem: VirtualItem) => React.ReactNode;
};

export const RowVirtualizer: React.FC<RowVirtualizerProps> = ({
  count,
  estimateSize,
  children,
  ...rest
}) => {
  const parentRef = React.useRef(null);

  const rowVirtualizer = useVirtualizer({
    count,
    getScrollElement: () => parentRef.current,
    estimateSize: () => estimateSize,
  });

  return (
    <Scrollbar.Wrapper gap={"$2.3"}>
      <Scrollbar.Track
        alignItems="center"
        backgroundColor={"$gray-200"}
        thickness={2}
      >
        <Scrollbar.Thumb
          backgroundColor={"$green-500"}
          borderRadius={"$5"}
          thickness={4}
        />
      </Scrollbar.Track>
      <ScrollView ref={parentRef} {...rest}>
        <View position="relative" height={rowVirtualizer.getTotalSize()}>
          {rowVirtualizer
            .getVirtualItems()
            .map((virtualItem) => children?.(virtualItem))}
        </View>
      </ScrollView>
    </Scrollbar.Wrapper>
  );
};
